import { API } from "aws-amplify";
import axios from 'axios';
import "containers/common/List.css";
import React, { Component } from "react";
import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import ReactTable from "react-table";
import 'react-table/react-table.css';
import { PacmanLoader } from 'react-spinners';
//import Moment from "moment";
const CancelToken = axios.CancelToken;
const source = CancelToken.source();


export default class EntityList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            entities: [],
            filter: {}
        };

        
        
        
        
    }
    

    async componentDidMount() {
        console.log("In EntityList componentDidMount");
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        if(this.props.filter!=={}){
            try {
                this.setState({ isLoading: true });      
                const entities = await this.getEntities(this.props.filter);
                this.setState({ entities });
            } catch (e) {
                alert(e);
            }
        }
        this.setState({ isLoading: false });      
    }

    componentWillUnmount() {
        source.cancel();
    }

    async componentDidUpdate(prevProps) {
        

        
        if (prevProps.filter !== this.props.filter) {
            this.setState({ isLoading: true });      

            const entities = await this.getEntities(this.props.filter);
            console.log(entities);
            this.setState({ entities });
            this.setState({ isLoading: false });     
        }
    }


    getEntities(filter) {
        console.log("Inside getEntities() ");
        console.log(filter);
        return API.get("colin", "/entities", {'queryStringParameters': filter}, {cancelToken: source.token });
      
    }


    renderTable(data) {
        const columns = [

            {
                id: 'entity_id',
                Header: 'Entity ID',
                maxWidth: 60,
                accessor: 'entity_id' ,
                Cell: e => <a target="_blank" rel="noopener noreferrer" href={`entities/${e.value}`}>{e.value} </a>

        }, 
            {
                id: 'inactive',
                Header: 'Inactive',
                maxWidth: 100,
                accessor: d => {
                    if (d.inactive) {
                        return (
                            <Form.Check checked={d.inactive}
                                label=""
                                type="checkbox"
                                disabled="True"
                                style={{
                                    textAlign: "center"
                                }}
                            />);
                    }
                    else { return null }
                },
                style: { textAlign: "center" }

            }, {
                id: 'name',
                Header: 'Name',
                maxWidth: 200,
                style: { 'white-space': 'unset' } ,
                accessor: 'name'

            }, {
                id: 'origin_entity_id',
                Header: 'Code',
                maxWidth: 100,
                style: { 'white-space': 'unset' } ,
                accessor: 'origin_entity_id'

            },{
                id: 'entity_contact',
                Header: 'Contact Name',
                maxWidth: 200,
                accessor: 'entity_contact',
                style: { 'white-space': 'unset' }

            },
            {
                id: 'telephone',
                Header: 'Telephone',
                maxWidth: 100,
                accessor: 'telephone',
                style: { 'white-space': 'unset' }

            },
            {
                id: 'managing_agents_count',
                Header: '# Managing Agents',
                maxWidth: 100,
                style: { 'white-space': 'unset', 'text-align': 'center' } ,
                accessor: 'managing_agents_count'
            },
            {
                id: 'leasing_agents_count',
                Header: '# Leasing Agents',
                maxWidth: 100,
                style: { 'white-space': 'unset', 'text-align': 'center' } ,
                accessor: 'leasing_agents_count'
            },
            {
                id: 'lift_operators_count',
                Header: '# Lift Operators',
                maxWidth: 100,
                style: { 'white-space': 'unset', 'text-align': 'center' } ,
                accessor: 'lift_operators_count'
            },
            {
                id: 'sales_count',
                Header: '# Sales',
                maxWidth: 100,
                style: { 'white-space': 'unset', 'text-align': 'center' } ,
                accessor: 'sales_count'
            },
            {
                id: 'sale_sheets_count',
                Header: '# Sale Sheets',
                maxWidth: 100,
                style: { 'white-space': 'unset', 'text-align': 'center' } ,
                accessor: 'sale_sheets_count'
            },
            {
                id: 'email',
                Header: 'Email',
                // maxWidth: 400,
                accessor: 'email',
                style: { 'overflow-wrap': 'break-word' }

            },
            {
                id: 'st_suburb',
                Header: 'Suburb',
                maxWidth: 100,
                accessor: 'st_suburb',
                style: { 'white-space': 'unset' }

            },
            {
                id: 'st_postcode',
                Header: 'Postcode',
                maxWidth: 75,
                accessor: 'st_postcode',
                style: { 'white-space': 'unset' }

            },
            {
                id: 'st_state',
                Header: 'State',
                maxWidth: 75,
                accessor: 'st_state',
                style: { 'white-space': 'unset' }

            }
            
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={20}
                    sortable={true}
                />
            )
        }



    }
    

    
    renderEntities() {
        return (
            <div className="entities">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                <Row >
                    <Col className="text-right" >
                            <LinkContainer to={`/entities/new`}>
                                <Button variant="primary"
                                
                                >Add</Button>
                                </LinkContainer>
                            
                                
                                
                        </Col>
                    </Row>
                    {this.props.controlType==="table"&&
                     <Row>
                        <Col><b>{this.state.entities.length} of {this.state.entities.length>0 ? this.state.entities[0].result_count: "0"} records returned.</b></Col>
                    </Row>
                    }
                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                        {this.state.isLoading &&
                        <div className="outer-div"><div className='sweet-loading inner-div' >
                            <PacmanLoader
                                css="display: block;
                                margin: 0 auto;
                                border-color: red"
                            sizeUnit={"px"}
                            size={20}
                            color={'#e03c31'}
                            loading={this.state.isLoading}
                            />
                    </div>
                        </div>}
                        {!this.state.isLoading ? this.props.controlType == "table" ? this.renderTable(this.state.entities) : this.renderTable([]) : this.renderTable([])  }
                        </Col>
                    </Row>
           

            </div>
        );
    }
  render() {
    return (

        <div className="EntityList">
            {this.props.isAuthenticated ? this.renderEntities() : console.log("error)")}
            
        </div>
    );
  }
}
